import * as React from 'react';
import {Button, Box} from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import { Link } from 'react-router-dom';
import logoutIcon from '../Components/assets/images/logout_icon.png';
import {toast } from 'react-toastify';

export default function LogoutModal() {
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    localStorage.clear();
    setTimeout(() => {
      toast.success('Logout Successfully');
    }, 1000);
    
  };


  return (
    <div>
      <Button variant="outlined" onClick={handleClickOpen}>
      <span><img src={logoutIcon} alt="icon" /></span>Logout
      </Button>
      <Dialog
        className='logout_bx'
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
             Are you want to logout?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Box className="btn_wpr">
            <Button className='btn-design' onClick={() => setOpen(false)}>Cancel</Button>
            <Link className='btn-design' to="/login" onClick={handleClose} autoFocus>
                Confirm
            </Link>
          </Box>
        </DialogActions>
      </Dialog>
    </div>
  );
}
